<template>

  <div>


    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status" :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="enterpriseContactId" :primary-key="form.enterpriseContactId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Contatos"
                 @onSubmit="onSubmit"
                 @onItemRead="onContactRead"
                 @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.enterpriseContactId" hidden/>

      <t-button v-show="!insertContact" class="mt-2 mb-2" @click="insertContact = true">
        <b-icon-plus/>
        Inserir novo
      </t-button>

      <t-form-card title="Cadastro de Novo" class="mt-2" v-show="insertContact">


        <b-col cols="12" class="mb-2" v-if="command !== 'view'">

          <b-row>


            <b-col xl="9">

              <b-row v-if="accountModule === 'estate'">

                <t-input radio required hide-label v-model="form.typeContactId"
                         :options="ContactType.list" label="Tipo"/>

              </b-row>

              <b-row>

                <t-input v-model="form.typePerson" label="Tipo Pessoa"
                         :options="typePersonOptions" radio/>

                <t-input cols="4"
                         v-model="form.name"
                         :add-error="error.name"
                         label="Nome/Empresa"
                         required/>

                <t-input cols="3" v-model="form.department"
                         label="Cargo/Repr. Legal"/>

                <t-input cols="4" v-model="form.tel" tel
                         label="Telefone"/>

                <t-input cols="4" v-model="form.email" email
                         label="E-mail"/>

                <t-input cols="4" v-model="form.federalTaxpayer" cnpj-or-cpf
                         label="CPF/CNPJ"/>

                <t-input cols="4" v-model="form.otherPersonalDocument"
                         label="RG/Insc. Estadual"/>

                <t-input cols="4" v-model="form.note" label="Obs."/>

              </b-row>

            </b-col>

            <b-col xl="3" class="button-form-inline">

              <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

              <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                {{ t('go-back') }}
              </b-link>

            </b-col>


          </b-row>


        </b-col>

      </t-form-card>

      <template #item(name)="{item}">

        <div>
          <b>{{ item.name }}</b>
        </div>
        <div v-if="objValid(item.typeContactId)">
          <b-badge variant="info" class="ml-2" v-if="item.typeContactId === ContactType.type.LOCATARIO">Locatário
          </b-badge>
          <b-badge variant="warning" class="ml-2" v-else-if="item.typeContactId === ContactType.type.FIADOR">Fiador
          </b-badge>
          <b-badge variant="focus" class="ml-2" v-else-if="item.typeContactId === ContactType.type.LOCADOR">Locador
          </b-badge>
          <b-badge variant="light" class="ml-2" v-else-if="item.typeContactId === ContactType.type.TESTEMUNHA">Testemunha</b-badge>
        </div>

        <small v-if="item.federalTaxpayer !== ''" class="mr-2">{{ item.federalTaxpayer }}</small>

      </template>


    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import ContactType from "@/model/types/resource/ContactType";
import ui from "@/assets/scripts/ui";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'EnterpriseContact',
  data() {
    return {
      ContactType,
      path: "place/enterprise-contact", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "enterpriseId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "enterpriseContactId", keyDelete: "enterpriseContactId"},
        {key: "name", label: "Nome", cols: "2"},
        {key: "department", label: "Cargo", cols: "2"},
        {key: "tel", label: "Tel", cols: "2"},
        {key: "email", label: "E-mail", cols: "2"},
        {key: "note", label: "Obs.", cols: "2"},
      ],
      form: {
        enterpriseId: this.foreignKey,
        enterpriseContactId: 0,
        name: "",
        department: "",
        federalTaxpayer: "",
        otherPersonalDocument: "",
        typeContactId: 0, //Por enquanto somente para o módulo Arch
        tel: "",
        email: "",
        note: "",
        status: 1,
      },
      error: {
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      typePersonOptions: [{value: 2, text: "Jurídica"}, {value: 1, text: "Física"}],
      insertContact: false,
      accountModule: "",
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      if (this.accountModule === 'estate' && this.isInsert()) {
        this.form.typeContactId = ContactType.type.LOCATARIO
      }


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

      this.accountModule = ui.getAccountModule()

    },

    async mountedContinued() {

      await this.getList()

      if (this.accountModule === 'estate' && this.isInsert()) {
        this.form.typeContactId = ContactType.type.LOCATARIO
      }

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.enterpriseContactId)

    },

    mountedList() {


      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async onContactRead(id) {
      this.insertContact = true
      await this.onItemReadDefault(id)
    }



    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
